import { analyticsClientConfig, type AnalyticsClientInterface } from './analyticsClient.types';
import CorporateAnalyticsClient from './corporateAnalyticsClient';
import GroupAnalyticsClient from './groupAnalyticsClient';
import OrgUnitAnalyticsClient from './orgUnitAnalyticsClient';
import type { ClientContext } from '~/services/contextClient';

export default class AnalyticsClientFactory {
    static createClient(context: ClientContext): AnalyticsClientInterface {
        if (!context.orgUnitId && !context.groupId) {
            return new CorporateAnalyticsClient(context.teamId, analyticsClientConfig);
        } else if (context.orgUnitId) {
            return new OrgUnitAnalyticsClient(context.teamId, context.orgUnitId, analyticsClientConfig);
        } else if (context.groupId) {
            return new GroupAnalyticsClient(context.teamId, context.groupId, analyticsClientConfig);
        }

        throw new Error('Invalid context');
    }
}
